import { render, staticRenderFns } from "./ExpandedRequestsChart.vue?vue&type=template&id=d8544a72&"
import script from "./ExpandedRequestsChart.vue?vue&type=script&lang=ts&"
export * from "./ExpandedRequestsChart.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandedRequestsChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports